import { render, staticRenderFns } from "./ContextSelectorWithPrefix.vue?vue&type=template&id=05348345&scoped=true&"
import script from "./ContextSelectorWithPrefix.vue?vue&type=script&lang=js&"
export * from "./ContextSelectorWithPrefix.vue?vue&type=script&lang=js&"
import style0 from "./ContextSelectorWithPrefix.vue?vue&type=style&index=0&id=05348345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05348345",
  null
  
)

export default component.exports